<template>
    <div>
        <!-- <h1>{{ $t('betalingfejl')}}</h1> -->
        <h1>Afbestilling</h1>
    </div>
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
    data() {
        return {
            locale: i18n.locale,
            apiLoaded: 0,
        };
    },
    created() {
    },
    methods: {
    }
}
</script>

<style scoped>

.flex-container {
  list-style: none;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction:row;
  -ms-flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}

.flex-item {
  padding: 10px;
  width: 85vw;
  max-width: 330px;
  height: 150px;
  margin-top: 10px;
  display: flex;
}

</style>